module.exports = __webpack_public_path__ + "img/close-light.df13156b.svg";